var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2c66ac920a739d50a442109ef0ee234baad122eb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["the-fridge@personal-website-c7"]={id:"2c66ac920a739d50a442109ef0ee234baad122eb"};
      